import { render, staticRenderFns } from "./customerRecord.vue?vue&type=template&id=7d5a431e&scoped=true&"
import script from "./customerRecord.vue?vue&type=script&lang=js&"
export * from "./customerRecord.vue?vue&type=script&lang=js&"
import style0 from "./customerRecord.vue?vue&type=style&index=0&id=7d5a431e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5a431e",
  null
  
)

export default component.exports